import * as React from 'react';

import Dropdown from 'af-components/Controls/Dropdown';

import type { ReportTypeFilterItem } from './types';
import styles from '../styles.module.scss';

type Props = {
	reportTypeOptions: ReportTypeFilterItem[];
	lazyLoadReportTypes: (loaded?: boolean) => Promise<void>;
	setFilterByReportType: (_selected: Nullable<ReportTypeFilterItem>) => void;
	defaultValue: Nullable<ReportTypeFilterItem>;
};
const ReportTypeFilter: React.FC<Props> = ({ lazyLoadReportTypes, reportTypeOptions, setFilterByReportType, defaultValue }) => {

	const filterTableByReportType = React.useCallback((_selectedValue: ReportTypeFilterItem) => {
		const selected = reportTypeOptions.find((_value) => _value.id === _selectedValue.id);
		setFilterByReportType(selected ?? null);
	}, [reportTypeOptions, setFilterByReportType]);

	const renderReportTypeMenuSelectedItem = React.useCallback((_reportType: ReportTypeFilterItem) => {
		return <>{_reportType?.name ? `${_reportType.name}` : ''}</>;
	}, []);

	const renderReportTypeMenuItem = React.useCallback((optionItem: ReportTypeFilterItem) => {
		return !!optionItem
			? <>{optionItem.name}</>
			: <>All report types</>;
	}, []);

	return (
		<div className={styles['filter-container']}>
			<Dropdown<ReportTypeFilterItem>
				className={styles['rtv-table__filter-button']}
				defaultValue={defaultValue ?? null}
				filterable={true}
				filterBy={['name']}
				fixed={true}
				id="report-type-view-rt-filter"
				labelKey="name"
				onLazyLoad={lazyLoadReportTypes}
				onValueChange={filterTableByReportType}
				options={reportTypeOptions}
				placeholder="Select Report Type"
				renderMenuItem={renderReportTypeMenuItem}
				renderSelected={renderReportTypeMenuSelectedItem}
				valueKey="id"
				withBorder={false}
				withCaret={true}
			/>
		</div>
	);
};

export default React.memo(ReportTypeFilter);

